import React from 'react';
import { Controller } from 'react-hook-form';
import TextField from '@mui/material/TextField';

const FormInputText = (props) => {
  const {
    name,
    control,
    label,
    type,
    shrink,
    multiline,
    rows,
    disabled,
    register,
    minValue,
    maxValue,
    readOnly,
    errors,
    helperText,
    placeholder,
  } = props;
  return (
    <Controller
      name={name}
      control={control}
      register={register}
      render={({
        field: { onChange, onBlur, value },
        fieldState: { error },
        formState,
      }) => (
        <TextField
          onChange={onChange}
          value={value == null ? '' : value}
          disabled={disabled}
          fullWidth
          label={label}
          type={type}
          variant='outlined'
          multiline={multiline}
          error={errors}
          helperText={helperText}
          placeholder={placeholder}
          rows={rows}
          onBlur={onBlur}
          InputLabelProps={{
            shrink: shrink,
          }}
          InputProps={{
            inputProps: { min: minValue, max: maxValue, readOnly: readOnly },
          }}
          style={{ marginBottom: '20px' }}
        />
      )}
    />
  );
};

export default FormInputText;
